import "./T4ReportDataGridWithColumnToggled.css";

import { Box, useTheme } from "@mui/material";
import {
	EnhancedButtonPrimeReactSeverity,
	formatDateToShow,
	useNavigateToLogout,
} from "../../../../common/Common";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { RequestParams, SplitButton } from "@websential/cosmic-v20";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { EnhancedButtonPrimeReact } from "../../../EnhancedButtonPrimeReact";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";

export interface IDataTable {
	rows: any;
	columns: any;
	completeHeaderColumnsList: any;
	submitAddRemoveColumnsHandler: (value: any) => void;
	onColumnReorder: (value: any) => void;
	showIndexColumn: boolean;
	showChecboxColumn: boolean;
	showSettingColumn: boolean;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	isLoading?: any;
	onSnackbarMessageData?: (value: any) => void;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	selectionToolbar?: (selectedItems: any) => React.ReactNode;
	selectedRowsValues?: any;
	changeLoginForGetEmptyItemsBySearchQuery?: any;
	searchFieldPlaceholder?: string;
	showGlobalSearch?: boolean;
	tableMargin?: string;
	rowsPerPageOptions?: number[];
	footer?: any;
	cardHeaderTitle?: string;
	cardHeaderSubTitle?: string;
	disabledHeaderTooltip?: boolean;
	viewIcon?: boolean;
	whiteSpace?: string;
	exportButton?: boolean;
	exportButtonLabel?: string;
	exportButtonInFileList?: boolean;
	// onExportButtonClick?: (event: string, params: any) => void;
	onExportButtonClick?: (event: string) => void;

	onExportButtonInFileListClick?: (event: string, params: any) => void;
	requestParamsToInitial?: boolean;
	tableScrollHeight?: boolean;
	pageTitle?: string;
	provinceOfEmployementDDL?: any;
	countryList?: any;
	provinceOrStateDDL?: any;
	employeeListTableData: (data: any) => void;
	onImportButtonClickedHandler?: () => void;
	onImportExcelButtonClickedHandler?: () => void;
}

export const T4ReportDataGridWithColumnToggled: React.FC<IDataTable> = ({
	rows,
	columns,
	completeHeaderColumnsList,
	submitAddRemoveColumnsHandler,
	onColumnReorder,
	showIndexColumn,
	showChecboxColumn,
	showSettingColumn,
	onRowDeleteClicked,
	onRowEditClicked,
	isLoading,

	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	selectionToolbar,
	selectedRowsValues,
	searchFieldPlaceholder,
	showGlobalSearch = true,
	tableMargin,
	rowsPerPageOptions,
	changeLoginForGetEmptyItemsBySearchQuery,
	footer,

	whiteSpace,

	exportButtonInFileList = false,

	requestParamsToInitial,
	tableScrollHeight,
	pageTitle,
	countryList,
	provinceOfEmployementDDL,
	employeeListTableData,
	onExportButtonClick,
	onImportExcelButtonClickedHandler,
	onImportButtonClickedHandler,
}) => {
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const navigateToLogout = useNavigateToLogout();
	const [completeHeaderColumnsListState, setCompleteHeaderColumnsListState] =
		useState({});
	const [columnss, setColumnss] = useState<any>([]);
	const [visibleColumns, setVisibleColumns] = useState<any>([]);
	const [employeeListData, setEmployeeListData] = useState<any>(rows && rows);
	const [employeeListItems, setEmployeeListItems] = useState<any>(undefined);

	useEffect(() => {
		if (rows && JSON.stringify(rows) !== JSON.stringify(employeeListItems)) {
			setEmployeeListItems(rows);
		}
	}, [rows]);

	useEffect(() => {
		employeeListTableData(employeeListItems);
	}, [employeeListItems]);

	useEffect(() => {
		if (
			completeHeaderColumnsList &&
			Object.keys(completeHeaderColumnsList).length > 0
		) {
			setCompleteHeaderColumnsListState(completeHeaderColumnsList);
		}
	}, [completeHeaderColumnsList]);

	useEffect(() => {
		if (Object.keys(completeHeaderColumnsListState).length > 0) {
			const updatedColumns = Object.entries(completeHeaderColumnsListState).map(
				([field, status]) => ({
					field,
					headerName: field
						.replace(/([A-Z])/g, " $1")
						.replace(/^./, (c) => c.toUpperCase()),
					status,
				})
			);
			setColumnss(updatedColumns);
			setVisibleColumns(updatedColumns.filter((col) => col.status));
		}
	}, [completeHeaderColumnsListState]);

	const [
		upadtedCompleteHeaderColumnsList,
		setUpadtedCompleteHeaderColumnsList,
	] = useState(columnss);

	const theme = useTheme();
	const [itemSearch, setItemSearch] = useState("");
	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	const [selectedItems, setSelectedItems] = useState<any>([]);
	const [selectedAuditEarningsItems, setSelectedAuditEarningsItems] =
		useState<any>([]);
	const [selectedItemsIds, setSelectedItemsIds] = useState<any>([]);

	const editColumn = (params: any) => {
		return (
			<>
				<EnhancedButtonPrimeReact
					icon={"pi pi-pencil"}
					onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					className="p-button-rounded p-button-text w-2rem h-2rem"
					rounded
				/>
			</>
		);
	};

	const deleteRowColumn = (params: any) => {
		return (
			<EnhancedButtonPrimeReact
				icon="pi pi-times"
				onClickHandler={() => onRowDeleteClicked && onRowDeleteClicked(params)}
				severity={EnhancedButtonPrimeReactSeverity.Danger}
				className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
				rounded
			/>
		);
	};

	const [itemSearsch, setItemSearsch] = useState("");
	const onSearchButtonClicked = () => {
		setLoading(true);
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: itemSearch,
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};
	const handleClearSearch = () => {
		setLoading(true);
		setItemSearch("");
		setRequestParams((prevParams: any) => ({
			...prevParams,
			first: initialPage,
			rows: initialPageSize,
			page: initialPage,
			searchQuery: "",
		}));
		if (changeLoginForGetEmptyItemsBySearchQuery) {
			changeLoginForGetEmptyItemsBySearchQuery(false);
		}
		setTimeout(() => {
			setLoading(false);
		}, 1000);
	};

	const onColumnToggle = (event: any) => {
		let selectedColumns = event.value;


		let orderedSelectedColumns = columnss.filter(
			(col: any) =>
				selectedColumns.some((sCol: any) => sCol.field === col.field) ||
				[
					"firstName",
					"lastName",

				].includes(col.field)
		);


		setVisibleColumns(orderedSelectedColumns);

		const currentColumnsStatus = columnss.map((col: any) => {
			const match = orderedSelectedColumns.find(
				(selected: { field: any }) => selected.field === col.field
			);
			return {
				...col,

				status: match ? true : false,
			};
		});
		setUpadtedCompleteHeaderColumnsList(currentColumnsStatus);
	};

	const onColumnSaveButtonClickedHandler = () => {
		const convertArrayToObjectOfAllColumnsFields =
			upadtedCompleteHeaderColumnsList.reduce(
				(acc: any, { field, status }: any) => ({ ...acc, [field]: status }),
				{}
			);

		submitAddRemoveColumnsHandler(convertArrayToObjectOfAllColumnsFields);
	};

	const panelFooterTemplate = () => {
		return (
			<div
				className="py-2 px-3"
				style={{
					display: "flex",
					justifyContent: "end",
				}}
			>
				<EnhancedButtonPrimeReact
					label="Save"
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					onClickHandler={onColumnSaveButtonClickedHandler}
				/>
			</div>
		);
	};

	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<MultiSelect
					value={visibleColumns}
					options={columnss}
					optionLabel="headerName"
					onChange={onColumnToggle}
					className="w-[250px]] sm:w-[250px]"
					placeholder="Add/Remove Columns"
					maxSelectedLabels={0}
					selectedItemsLabel="Add/Remove Columns"
					panelFooterTemplate={panelFooterTemplate}
					optionDisabled={(option) =>
						option.field === "firstName" ||
						option.field === "lastName"

					}
				/>
				{showGlobalSearch && (
					<span
						className="p-input-icon-left w-3"
						style={{
							display: "flex",
							marginLeft: "10px",
							height: "37px",
							maxWidth: "250px",
						}}
					>
						<i className="pi pi-search" />
						<InputText
							value={itemSearch}
							onChange={(e) => setItemSearch(e.target.value)}
							placeholder={
								searchFieldPlaceholder ? searchFieldPlaceholder : "Search..."
							}
							className="w-full"
							style={{ borderRadius: "2px 0px 0px 2px" }}
						/>
						{itemSearch && (
							<Button
								icon="pi pi-times"
								onClick={handleClearSearch}
								className="p-button-warning"
								style={{ borderRadius: 0 }}
							/>
						)}
						<Button
							onClick={onSearchButtonClicked}
							severity={EnhancedButtonPrimeReactSeverity.Secondary}
							style={{
								// padding: "10px 22px 10px 10px",

								// borderRadius: "0px 2px 2px 0px",
								// fontSize: ".875rem",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								borderRadius: "0px 2px 2px 0px",
								fontSize: ".875rem",
							}}
						>
							Search
						</Button>
					</span>
				)}
				{/* <Box
					sx={{
						padding: "0 10px",
						display: "flex",
						alignItems: "center",
					}}
				>
					<i
						className={"pi pi-file-export"}
						// onClick={handleImportIconClicked}
						onClick={onImportButtonClickedHandler}
						style={{ cursor: "pointer" }}
					/>
					<i
						className={"pi pi-file-excel"}
						// onClick={() => navigate("/logout")}
						onClick={onImportExcelButtonClickedHandler}
						style={{ cursor: "pointer", marginLeft: "1rem" }}
					/>
				</Box> */}

				{rows && rows.length > 0 ? (
					<Box
						sx={{
							marginInline: "1rem",
							// textTransform: "capitalize",
							// display: "inline-block",
							"& .MuiPopper-root": { zIndex: 2, left: "-17px", width: "155px" },
							"& .MuiBox-root " :{
										background: theme.palette.primary.main
									},
							// width: "193px",
							// "& .MuiMenuItem-root:first-child":{display:"none"},
						}}
					>
						<SplitButton
							options={["CSV", "XLS", "PDF"]}
							onClickHandler={(selectedOption) =>
								onExportButtonClick && onExportButtonClick(selectedOption)
							}
							testId="t4-print-button"
							icon={<ExitToAppIcon />}
							listItemsLabel={`Export To`}
						/>
					</Box>
				 ) : (
				 	<></>
				 )}
				{selectionToolbar && selectionToolbar(selectedItems)}
			</div>
		);
	};
	const headerSearch = renderHeader();
	function search(_row: any) {
		return (
			rows &&
			rows.filter(
				(rows: any) =>
					rows.clientName.props.children
						.toLowerCase()
						.indexOf(itemSearsch.toLowerCase()) > -1
			)
		);
	}

	const onPage = (event: any) => {
		setLoading(true);

		setTimeout(() => {
			setRequestParams({
				...event,
				searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};
	const onColReorder = (event: any) => {
		const dragIndex = event.dragIndex - 1;
		const dropIndex = event.dropIndex - 1;

		if (dragIndex < 0 || dropIndex < 0 || dragIndex === dropIndex) return;

		const updatedColumns = [...columns];
		const [movedItem] = updatedColumns.splice(dragIndex, 1);
		updatedColumns.splice(dropIndex, 0, movedItem);

		const reSequenced = updatedColumns.map((col, idx) => ({
			...col,
			sequence: idx,
		}));

		onColumnReorder(reSequenced);
	};
	const [sortField, setSortField] = useState(null);
	const [sortOrder, setSortOrder] = useState(1);
	const onSort = useCallback(
		(event: any) => {
			setLoading(true);

			let newSortOrder: any;
			if (event.sortField === sortField) {
				newSortOrder = sortOrder === 1 ? -1 : 1;
				setSortOrder(newSortOrder);
			} else {
				newSortOrder = 1;
				setSortField(event.sortField);
				setSortOrder(newSortOrder);
			}

			setRequestParams((prevParams: any) => ({
				...prevParams,
				sortOrder: newSortOrder !== 1 ? "asc" : "desc",
				sortField: event.sortField,
			}));

			setTimeout(() => {
				setLoading(false);
			}, 1000);
		},
		[sortOrder, sortField]
	);

	useEffect(() => {
		if (onRequestParamsChange) {
			if (isInitialRequest.current === true) {
				isInitialRequest.current = false;
			} else {
				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams, requestParamsToInitial]);

	useEffect(() => {
		if (requestParamsToInitial && requestParams.first !== initialPage) {
			setRequestParams({
				first: initialPage,
				rows: initialPageSize,
				page: initialPage,
				sortField: null,
				sortOrder: "asc",
				searchQuery: "",
				filters: {
					name: { value: "", matchMode: "contains" },
					"country.name": { value: "", matchMode: "contains" },
					company: { value: "", matchMode: "contains" },
					"representative.name": { value: "", matchMode: "contains" },
				},
			});
		}
	}, [requestParamsToInitial, onRequestParamsChange, requestParams]);

	const onSelectionModelChange = useCallback(
		(items: any) => {
			let selectedItemsIds = items.value.map((item: any) => item.id);

			const updatedSelectedItems = items.value.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
			setSelectedItems(updatedSelectedItems);
			setSelectedAuditEarningsItems(updatedSelectedItems);
			setSelectedItemsIds(selectedItemsIds);
			if (selectedRowsValues) {
				if (items.value.length > 0) {
					const selectedRowData = rows.filter((row: any) => {
						return items.value.includes(row);
					});

					selectedRowsValues(selectedRowData);
				} else {
					selectedRowsValues(items.value);
				}
			}
		},
		[rows, selectedRowsValues, selectedItems]
	);
	useEffect(() => {
		// Check for deleted items and remove them from selectedItems
		const updatedSelectedItems =
			selectedItems &&
			selectedItems.length > 0 &&
			selectedItems.filter((selectedItem: any) => {
				return rows && rows.find((row: any) => row.id === selectedItem.id);
			});
		// Only update if there are changes to selectedItems
		if (
			updatedSelectedItems &&
			updatedSelectedItems.length !== selectedItems.length
		) {
			setSelectedItems(updatedSelectedItems);

			// Update selectedItemsIds
			const updatedSelectedItemsIds = updatedSelectedItems.map(
				(item: any) => item.id
			);
			setSelectedItemsIds(updatedSelectedItemsIds);
		}
	}, [rows, selectedItems, selectedAuditEarningsItems]);

	const columnsBody = (rowData: any, row: any, x: any) => {
	return <span>{rowData[x.field]}</span>;
	};

	// row highlighting (yellow background) when clicking any cell in that row
	const [activeRowIndex, setActiveRowIndex] = useState<string[]>([]);
	
	const getRowKey = (row: any) => {
		return `${row.employeeId}__${row.provinceId}`;
	};
	const getRowClassName = (rowData: any) => {
		const key = getRowKey(rowData);
		return activeRowIndex.includes(key) ? "highlighted-row" : "";
	};

	const onRowClickHandler = (e: any) => {
		const key = getRowKey(e.data);

		setActiveRowIndex((prev: any) => {
			if (prev.includes(key)) {
				return prev.filter((k: any) => k !== key);
			}
			return [...prev, key];
		});
	};

	return (
		<>
			<DataTable
				value={
					rows &&
					columns &&
					visibleColumns.length > 0 &&
					rows &&
					employeeListItems
				}
				responsiveLayout="scroll"
				lazy
				dataKey="id"
				paginator
				first={requestParams.first}
				rows={requestParams.rows}
				totalRecords={totalRecords}
				onPage={onPage}
				rowsPerPageOptions={rowsPerPageOptions}
				paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
				currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
				selection={selectedItems}
				onSelectionChange={onSelectionModelChange}
				editMode=""
				selectionMode={"checkbox"}
				showGridlines
				resizableColumns
				columnResizeMode="expand"
				scrollable
				scrollHeight={tableScrollHeight ? "75vh" : ""}
				// // reorderableColumns
				// onColReorder={onColReorder}
				loading={isLoading ? isLoading : loading}
				header={searchFieldPlaceholder ? headerSearch : undefined}
				footer={footer ? footer : undefined}
				emptyMessage={
					rows && rows.length === 0 ? "No Record Found." : "Loading..."
				}
				className="T4ReportDataGridWithColumnToggled"
				style={{
					margin: `${tableMargin ? tableMargin : "16px 0 0.5rem 0"}`,
				}}
				sortMode="single"
				onSort={onSort}
				// row highlighting (yellow background) when clicking any cell in that row
				rowClassName={getRowClassName}
				onRowClick={onRowClickHandler}
			>
				{columns && visibleColumns.length > 0 && (
					<Column
						selectionMode="multiple"
						hidden={!showChecboxColumn}
						frozen
						resizeable={false}
						style={{ width: "36px", textAlign: "center" }}
						field="selection"
						alignFrozen="left"
						columnKey="selection"
						className="selectionHeader"
						headerClassName="selectionHeader"
					></Column>
				)}
				{columns && visibleColumns.length > 0 && rows && rows.length > 0 && (
					<Column
						body={(rowData: any, row: any) => <span>{row.rowIndex + 1}</span>}
						header="#"
						hidden={!showIndexColumn}
						style={{ width: "60px", textAlign: "center" }}
						frozen
						alignFrozen="left"
						resizeable={false}
						reorderable={false}
						sortable={false}
						className="indexColumn"
						headerClassName="indexColumn"
					/>
				)}
				{rows && rows.length ? (
					<Column
						body={editColumn}
						style={{ width: "36px" }}
						hidden={!showSettingColumn}
						resizeable={false}
						reorderable={false}
						frozen
						alignFrozen="left"
						headerClassName="settingHeader"
					></Column>
				) : undefined}

				{columns &&
					columns
						.sort((a: any, b: any) => (a.sequence ?? 0) - (b.sequence ?? 0))
						.map((x: any, index: any) => {
							return (
								<Column
									key={index}
									field={x.field}
									header={x.headerName}
									headerTooltipOptions={{ position: "top" }}
									hidden={x.hide}
									sortable={x.sortable}
									dataType={x.type}
									align={x.align}
									alignHeader={x.headerAlign}
									exportable={x.disableExport}
									frozen={x.frozenColumn}
									alignFrozen={x.alignFrozen}
									columnKey={x.field}
									style={{
										minWidth: x.minWidth,
										fontSize: "0.875rem",
										maxWidth: x.maxWidth,
									}}
									headerStyle={{
										whiteSpace: whiteSpace ? whiteSpace : "nowrap",
									}}
									footer={x.footer}
								// body={(rowData: any, row: any) =>
								// 	columnsBody(rowData, row, x)
								// }
								/>
							);
						})}

				{rows && rows.length ? (
					<Column
						body={deleteRowColumn}
						style={{
							width: "36px",
							position: exportButtonInFileList ? "relative" : "sticky",
							overflow: exportButtonInFileList ? "visible" : "hidden",
						}}
						hidden={!showSettingColumn}
						resizeable={false}
						reorderable={false}
						frozen
						alignFrozen="right"
						className="settingHeader"
						headerClassName="settingHeader"
					></Column>
				) : undefined}
			</DataTable>
		</>
	);
};
